import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Article } from '../../../common/model/dto/article';
import { RecordColumn } from '../../../common/model/ui/record-list.type';
import { OrderBy } from '../../../common/types';
import OvRecordList from './OvRecordList';

interface OvArticleListProps {
  articles: Article[];
  columns: RecordColumn<Article>[];
  getNavigationState: () => unknown;
  orderBy: string;
  orderDir: string;
  onSort: (order: OrderBy) => void;
}

const OvArticleList: FC<OvArticleListProps> = ({
  articles,
  columns,
  getNavigationState,
  orderBy,
  orderDir,
  onSort,
}) => {
  const { t } = useTranslation();

  return (
    <OvRecordList
      label={t('common.articles')}
      records={articles}
      columns={columns}
      getKey={(article) => article.id as string}
      getDetailsPath={(article) => `/articles/detail/${article.id}`}
      getNavigationState={getNavigationState}
      orderBy={orderBy}
      orderDir={orderDir}
      onSort={onSort}
    />
  );
};

export default OvArticleList;
